import * as React from 'react'
import { JobField } from 'epc-schema'
import { Form, Indicators, Input } from 'ui'
import { useJobFieldsQuery } from './graphql'

interface IJobFieldGroupRendererProps {
  disabled?: boolean
  name: string
  jobField: string
}

export function JobFieldGroupRenderer<
  T
>(): React.FC<IJobFieldGroupRendererProps> {
  const CheckBoxGroupField = Input.CheckBoxGroupRenderer<T>()

  const JobFieldGroup: React.FC<IJobFieldGroupRendererProps> = (props) => {
    const { data, loading } = useJobFieldsQuery({
      fetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
      variables: { jobField: props.jobField },
    })
    const jobFields =
      (data && data.response && data.response.jobFields) || ([] as JobField[])
    return (
      <Form.Row>
        <Form.Item>
          {loading ? (
            <Indicators.Spinner size={'lg'} />
          ) : (
            <CheckBoxGroupField
              disabled={props.disabled}
              required={true}
              inline={true}
              inputWidth={1 / 2}
              name={props.name}
              values={jobFields
                .map((j) => j as JobField)
                .map((j) => ({ label: j.lowerLevel, value: j.id }))}
            />
          )}
        </Form.Item>
      </Form.Row>
    )
  }

  return JobFieldGroup
}
